var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26007 10.147C3.98502 12.2526 3.82112 14.3712 3.76907 16.494C6.64786 17.6966 9.40423 19.1734 12.0001 20.904C14.5962 19.1733 17.3529 17.6965 20.2321 16.494C20.18 14.3712 20.0161 12.2526 19.7411 10.147M19.7411 10.147C20.6161 9.85304 21.5031 9.58104 22.3991 9.33304C19.1356 7.04529 15.6521 5.08892 12.0001 3.49304C8.34806 5.08926 4.86447 7.04596 1.60107 9.33404C2.49436 9.58064 3.38069 9.85174 4.25907 10.147C6.92773 11.0442 9.51701 12.162 12.0001 13.489C14.4828 12.1621 17.0728 11.0442 19.7411 10.147ZM6.75007 15C6.94899 15 7.13975 14.921 7.2804 14.7804C7.42106 14.6397 7.50007 14.449 7.50007 14.25C7.50007 14.0511 7.42106 13.8604 7.2804 13.7197C7.13975 13.5791 6.94899 13.5 6.75007 13.5C6.55116 13.5 6.3604 13.5791 6.21974 13.7197C6.07909 13.8604 6.00007 14.0511 6.00007 14.25C6.00007 14.449 6.07909 14.6397 6.21974 14.7804C6.3604 14.921 6.55116 15 6.75007 15ZM6.75007 15V11.325C8.44681 10.2704 10.1994 9.30831 12.0001 8.44304M4.99307 19.993C5.55105 19.4364 5.99351 18.7751 6.29504 18.0469C6.59656 17.3187 6.75121 16.5382 6.75007 15.75V14.25",
    stroke: "inherit",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.730a16f176d46d036c3a11410a38cac0.svg";
export { ForwardRef as ReactComponent };